import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_SWITCH = gql`
  mutation deleteSwitch($input: DeleteNodeInput!) {
    deleteSwitch(input: $input)
  }
`;

export const deleteSwitch = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_SWITCH, { input: { propertyId, nodeId } });
};
